const Kolang = {
  登录: '로그인',
  密码: '비밀번호',
  '邮箱账号/会员账号': '메일주소/회원계정',
  请选择地区: '지역을 선택하세요',
  充值游戏: '게임',
  账号: '계정',
  请选择角色信息: '캐릭터 선택하세요',
  地区: '지역',
  切换地区: '지역변경',
  请选择游戏: '게임 선택하세요',
  请选择区服: '서버 선택하세요',
  请选择支付方式: '결제 방식',
  再次充值: '다시충전',
  '抱歉，您的充值失败': '죄송합니다. 결제 실패',
  请选择充值金额: '충전금액 선택하세요',
  请确认支付信息: '결제정보 확인하세요',
  游戏: '게임',
  服务器: '서버',
  角色: '캐릭터',
  订单金额: '주문금액',
  立即充值: '즉시충전',
  请您在新打开的页面完成支付: '팝압창에 지불을 완성하세요.',
  完成支付: '지불완성',
  支付出现问题: '지불 과정중 오류 발생했습니다',
  '恭喜您，充值成功': '충전성공',
  继续充值: '계속충전',
  个人中心: '내정보',
  充值记录: '충전기록',
  退出: '퇴장',
  全部: '전체',
  支付失败: '지불실패',
  购买失败: '구매실패',
  购买中: '구매중',
  订单状态: '주문상태',
  充值成功: '충전성공',
  搜索: '검색',
  充值时间: '충전시간',
  充值类型: '충전종류',
  游戏名称: '게임명',
  详情: '내역',
  查看详情: '내역조회',
  使用第三方登录: '연동계정 방식 사용',
  '如果您用信用卡支付，请确认您的充值金额没有超过该信用卡的线上交易限额':
    '신용카드로 결제시 충전금액이 신용카드의 거래상한을 초과하는지 확인하세요',
  'MyCard系统于每周一早上8:00 - 9:30进行系统维护，使用MyCard储值的玩家请在维护时间过后再进行储值':
    'MyCard시스템은 매주 월요일 8:00 - 9:30에 점검이 진행됩니다. 해당 시간대에 결제 진행하지 마세요',
  '如果您在储值过程中有任何疑问或问题，可与我们的客服联系，我们会给予您必要的帮助':
    '결제 과정중 문의가 있거나 도움이 필요하실 경우 저희 고객센터에 연락하세요. 확인 후 도와드리겠습니다',
  充值中心: '충전센터',
  区服: '서버',
  订单详情: '주문정보',
  订单号: '주문번호',
  充值平台币: '충전 T코인',
  充值方式: '충전방식',
  商品项: '상품',
  钱包: '주머니',
  钱包余额: '지갑잔액',
  请填写账号: '계정을 입력하세요',
  请填写密码: '비번을 입력하세요',
  请先选择游戏: '게임 선택하세요',
  请先选择支付方式: '지불방식 선택하세요',
  请重新登录: '다시 로그인 하세요',
  请先选择充值金额: '금액 선택하세요',
  请先选择区服: '서버 선택하세요',
  请先选择角色: '캐릭터 선택하세요',
  温馨提示: 'Tips',
  充值未完成: '충전미완성',
  暂无数据: '데이터 없음',
  '登录已过有效期，请重新登录':
    '로그인된 기한이 지나니 다시 로그인해 주십시오.',
  语言: '언어',
  额外赠送: '추가증정',
  Google登录: '구글 로그인',
  Facebook登录: '페이스북 로그인',
  T币: 'T coins',
  客服中心: '고객센터',
  欢迎: '환영합니다',
  一般充值: '소액 충전',
  大额充值: '거액 충전',
  充值: '충전',
  支付金额: '충전 금액',
  立即支付: '구매하기',
  个人: '개인',
  退出账号: '로그아웃',
  客服: '고객센터',
  帐号类: '계정 관련',
  储值类: '결제 관련',
  登录类: '접속 관련',
  VIP类: 'VIP',
  游戏类: '이용 관련',
  T币使用说明: 'T코인 사용 설명',
  'T币是购买少女芯平台上虚拟商品的通用代币，目前可用于购买少女芯平台上的水晶道具。':
    'T코인은 소녀스튜디오 플랫폼에서 가상상품을 구매할 수 있는 통화이고 플랫품에서 수정 아이템 구매 가능하다.',
  '1.T币和美元的兑换比例为：1T=0.1美元。': '1. T코인•달러 환율: 1T = 0.1달러',
  '2.若支付金额>应付金额（比如元宝价格为9.99美金，您支付了10美金），则您的支付金额超出部分（0.1美金）将转换为T币存入您的钱包。':
    '2. 실제 결제금액이 지불해야 할 금액을 초과하면 (즉 황금 가격은 9.99달러인데 고객님께서 10달러를 지불할 경우) 초과금액(0.1달러)는 T코인으로 전환되어 지갑에 저금될 것이다.',
  '3.同理，若支付金额< 应付金额，本次支付金额将转换为T币存入您的钱包。':
    '3. 실제 지불금액이 결제가격에 비해 부족할 경우 해당 금액은 T코인으로 전환되어 지갑에 저금될 것이다. ',
  溫馨提示: '사용 안내',
  '1.如果您用信用卡支付，请确认您的储值金额没有超过该信用卡的线上交易限额。':
    '1. 신용카그로 결제하신 경우는, 먼저 신용카드 기존 찬액이 온라인 거래 정액을 초과하지 않는 것을 확보하시길 바합니다.',
  '2.MyCard系统于每周一早上8:00 - 9:30进行系统维护，使用MyCard储值的玩家请在维护时间过后再进行储值。':
    '2. MyCard시스템 검점시간은 월요일마다 아침8:00부터 9:30까지 실시할 예정이오니, MyCard를 이용하신 고객님께서 검점시간이 끝난 후 거래를 진행하시길 바랍니다.',
  '如果您在储值过程中有任何疑问或问题，可与我们的客服联系，我们会给予您必要的帮助。客服邮箱：hwkf@99trillion.com，或前往':
    '거래를 진행하는 중에 궁금하신 사항은 언제든지 고객센터를 통해 접수해주시면 친절하게 안내해 드리겠습니다. ',
  '寻求帮助。': '',
  首页: '홈',
  推荐游戏: '게임 추천',
  游戏下载: '다운로드',
  热门活动: '이벤트',
  更多资讯: '더보기',
  '©2019 Trigirls Studio 工作室版权所有，页面内所有提及商标及素材均为其所有。':
    'Copyright @Trigirls Studio. All Rights Reserved.',
  隐私协议: '이용약관',
  用户协议: '개인정보처리방침',
  请选择要充值的游戏产品: '게임 선택',
  更换地区: '지역선택',
  游戏充值: '충전',
  更换游戏: '게임선택',
  请选择充值数量: '상품 선택  ',
  wallet: '지갑',
  应付金额: '상품금액',
  确认订单: '확인',
  充值说明: '충전설명',
  粉丝页: '커뮤니티'
};
export default Kolang;



// WEBPACK FOOTER //
// ./src/common/lang/ko.js